import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisH,
  faTrash,
  faPlay,
  faEllipsisV,
  faShare,
  faPause,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageHeaderTitle from "../components/pages/PageHeaderTitle";
import PageContainer from "../components/pages/PageContainer";
import DashboardHeader from "../components/Other/DashboardHeader";
import {
  deleteSavePost,
  getSavedPost,
  getSavedCharts,
  shareCartAsPostApi,
  getFollowersListApi,
  shareSavedChartApi,
  deleteSavedChart,
} from "../api/user";
import { toast } from "react-toastify";
import logo from "../images/logo.png";
import GreenTick from "../images/green-tick.png";
import SmallLoader from "../components/smallLoader";
import moment from "moment";
import { PreviewVideo } from "./previewVideo";
import FollowersListModal from "../components/Modals/followersListModal";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

const SavedPost = () => {
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const [savedPost, setSavedPost] = useState([]);
  const [savedCharts, setSavedCharts] = useState([]);
  const [isDataFeteched, setisDataFeteched] = useState(false);
  const [sidebarToggle] = useOutletContext();
  const [chart, setChart] = useState([]);
  const [selectedTab, setSelectedTab] = useState("savedPost");
  const isMobileView = document.body.clientWidth <= 768;
  const [showFullDescription, setShowFullDescription] = useState([]);
  const [dropdownStates, setDropdownStates] = useState(
    savedPost.map(() => false)
  );
  const [dropdownStates1, setDropdownStates1] = useState(
    savedCharts.map(() => false)
  );
  const [shareChartData1, setShareChartData1] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newid, setNewId] = useState("");
  const [loader, setLoader] = useState(false);
  const [isFollowersOpen, setIsFollowersOpen] = useState(false);
  const [followersList, setFollowersList] = useState([]);
  const [selectedIndices, setSelectedIndices] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [chartId, setChartId] = useState(null); // State to store chart id
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [last_page, setlast_page] = useState();
  const [hasMore, setHasMore] = useState(true);

  const handleImageLoaded = (event, imageIndex) => {
    const image = event.target;
    const linkElement = image.closest("a");
    linkElement.setAttribute("data-pswp-width", image.naturalWidth);
    linkElement.setAttribute("data-pswp-height", image.naturalHeight);
  };
  const galleryStyles = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gridGap: "20px",
  };

  const imageStyles = {
    width: "auto",
    height: "auto",
    objectFit: "cover",
    // border: "1px solid #ccc",
  };

  const linkStyles = {
    background: "#f0f0f0",
    // padding: "1px",
    margin: "10px",
  };

  const handleShareToFollowers = async (id, index) => {
    setSelectedIndices([...selectedIndices, index]);
    const obj = {
      chart_id: shareChartData1?.id,
      users: id,
    };
    const res = await shareSavedChartApi(obj);
    if (res?.data?.status == 200) {
    } else {
      setSelectedIndices(selectedIndices.filter((i) => i !== index));
      toast.error(res?.data?.message);
    }
  };

  const handleShareCancel = () => {
    setIsFollowersOpen(false);
  };

  useEffect(() => {
    getFollowersList();
  }, []);

  const getFollowersList = async () => {
    const res = await getFollowersListApi();
    if (res?.data?.status == 200) {
      setFollowersList(res?.data?.data?.data);
    }
  };

  const fetchSavedCharts = async () => {
    try {
      setLoader(true);
      const response = await getSavedCharts();
      if (response && response?.data && response?.data?.status == 200) {
        setisDataFeteched(true);
        setLoader(false);
        // console.log(response.data.data.data, "saved posts");
        setSavedCharts(response.data.data.data);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.error("Error fetching saved posts:", error);
    }
  };

  const renderDescriptionDynamicLineBreaks = (description) => {
    // Check if description is null or undefined
    if (!description || description == null) {
      return null;
    }

    // Regular expression to match one or more newline characters
    const regex = /(\n+)/g;

    // Split the description by the regex, keeping the delimiter
    const parts = description.split(regex);

    return parts.map((part, index) => {
      if (part.match(regex)) {
        // For newline characters, return a series of <br /> elements equal to the count of \n minus 1
        return [...Array(part.length - 1)].map((_, brIndex) => (
          <br key={`br-${index}-${brIndex}`} />
        ));
      } else {
        // For regular text, return a paragraph
        return <p key={`text-${index}`}>{part}</p>;
      }
    });
  };

  useEffect(() => {
    if (selectedTab == "savedCharts") fetchSavedCharts();
  }, [selectedTab]);

  const fetchSavedPosts = async () => {
    try {
      setLoader(true);
      const response = await getSavedPost(page);
      if (response?.data?.data) {
        setisDataFeteched(true);
        setLoader(false);
        // console.log(response.data.data, "saved posts");
        const posts = response?.data?.data?.data || [];
        console.log(response.data.data.last_page, "pa");
        setlast_page(response.data.data.last_page);
        setSavedPost(posts);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.error("Error fetching saved posts:", error);
    }
  };
  useEffect(() => {
    if (selectedTab == "savedPost") fetchSavedPosts();
  }, [selectedTab]);

  const onShareChartClick = async (chart) => {
    console.log(chart, "chart");
    setPreview(false);
    try {
      setLoader(true);
      const response = await deleteSavedChart(chart.id);
      if (response?.data?.data) {
        console.log(response);
        toast.success(response.data.message);
        fetchSavedCharts();
        // setisDataFeteched(true);
        setLoader(false);
        // // console.log(response.data.data, "saved posts");
        // const posts = response?.data?.data?.data || [];
        // setSavedPost(posts);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.error("Error fetching saved posts:", error);
    }
  };

  const toggleDropdown = (index) => {
    const newDropdownStates = [...dropdownStates];
    newDropdownStates[index] = !newDropdownStates[index];
    setDropdownStates(newDropdownStates);
  };

  const toggleDropdown1 = (index) => {
    const newDropdownStates = [...dropdownStates1];
    newDropdownStates[index] = !newDropdownStates[index];
    setDropdownStates1(newDropdownStates);
  };

  const calculateTimeDifference = (createdAt) => {
    const currentDate = new Date();
    const createdAtDate = new Date(createdAt);

    // Ensure time difference is non-negative
    const timeDifference = Math.max(
      0,
      currentDate.getTime() - createdAtDate.getTime()
    );

    const secondsInMs = 1000;
    const minutesInMs = secondsInMs * 60;
    const hoursInMs = minutesInMs * 60;
    const daysInMs = hoursInMs * 24;
    const monthsInMs = daysInMs * 30; // Note: Approximation, as months have varying numbers of days
    const yearsInMs = daysInMs * 365; // Note: Does not account for leap years

    if (timeDifference < secondsInMs) {
      return "just now";
    } else if (timeDifference < minutesInMs) {
      return Math.round(timeDifference / secondsInMs) + "s ago";
    } else if (timeDifference < hoursInMs) {
      return Math.round(timeDifference / minutesInMs) + "m ago";
    } else if (timeDifference < daysInMs) {
      return Math.round(timeDifference / hoursInMs) + "h ago";
    } else if (timeDifference < monthsInMs) {
      return Math.round(timeDifference / daysInMs) + "d ago";
    } else if (timeDifference < yearsInMs) {
      // Change 'm' to 'mo' to avoid confusion with 'minutes'
      return Math.round(timeDifference / monthsInMs) + "mo ago";
    } else {
      return Math.round(timeDifference / yearsInMs) + "y ago";
    }
  };

  const handleOpenModal = (postId) => {
    setIsModalOpen(true);
    setNewId(postId);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const handleDeletePost = async (postId) => {
    // console.log(postId);
    handleOpenModal();
    setNewId(postId);
  };
  const handleDelete = async () => {
    try {
      // const isConfirmed = window.confirm("Are you sure you want to delete this post?");
      // if (isConfirmed) {
      // Make API call to delete the post
      const response = await deleteSavePost(newid); // You need to implement this function

      if (response.status === 200) {
        // Remove the deleted post from the state
        setSavedPost((prevPosts) =>
          prevPosts.filter((post) => post.id !== newid)
        );
        // toast.success("Post deleted successfully");
        fetchSavedPosts();
        handleCloseModal();
      } else {
        throw new Error("Failed to delete the post");
        toast.error("Failed to delete the post");
      }
      // }
    } catch (error) {
      console.error(error);
      // Handle error
    }
  };

  const handleTabChange = (tab) => {
    setSelectedTab(tab);
    setLoader(true);

    setTimeout(() => {
      setLoader(false);
    }, 1000);
  };
  function calculateTimeAgo(created_at) {
    const currentDate = new Date();
    const createdAtDate = new Date(created_at);

    const days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
    const day = days[createdAtDate.getDay()];

    const hours = String(createdAtDate.getHours()).padStart(2, "0");
    const minutes = String(createdAtDate.getMinutes()).padStart(2, "0");

    // Ensure time difference is non-negative
    const timeDifference = Math.max(
      0,
      currentDate.getTime() - createdAtDate.getTime()
    );

    const secondsInMs = 1000;
    const minutesInMs = secondsInMs * 60;
    const hoursInMs = minutesInMs * 60;
    const daysInMs = hoursInMs * 24;
    const weeksInMs = daysInMs * 7;
    const monthsInMs = daysInMs * 30; // Note: Approximation, as months have varying numbers of days

    if (timeDifference < weeksInMs) {
      return `${day} ${hours}:${minutes}`;
    } else if (timeDifference < monthsInMs) {
      // If it's within a month, return the formatted date
      const month = String(createdAtDate.getMonth() + 1).padStart(2, "0");
      const year = createdAtDate.getFullYear();
      return `${day} ${hours}:${minutes} - ${createdAtDate.getDate()}/${month}/${year}`;
    } else {
      // If it's more than a month, return the formatted date with year
      const month = String(createdAtDate.getMonth() + 1).padStart(2, "0");
      const year = createdAtDate.getFullYear();
      return `${day} ${hours}:${minutes} - ${createdAtDate.getDate()}/${month}/${year}`;
    }
  }
  const [preview, setPreview] = useState(false);
  const [activeImage, setActiveImage] = useState("");

  // Function to open the preview modal
  const showPreview = (image) => {
    setActiveImage(image);
    setPreview(true);
  };

  const videoExtensionsRegex = /\.(mp4|mov|avi|wmv)$/i;

  const [isPreviewVideo, setIsPreviewVideo] = useState(false);
  const [attachments, setAttachments] = useState("");

  const [currentVideoIndex, setCurrentVideoIndex] = useState(null);

  const [showVideos, setShowVideos] = useState(
    new Array(savedPost?.length).fill(false)
  );

  const handlePlayClick = (index) => {
    const video = document.querySelector(`#video-${index}`);
    const playButton = document.querySelector(`#play-button-${index}`);

    if (currentVideoIndex !== null && currentVideoIndex !== index) {
      const currentVideo = document.querySelector(
        `#video-${currentVideoIndex}`
      );
      currentVideo.pause();
    }

    if (video?.paused) {
      video.play();
      setCurrentVideoIndex(index);
      playButton.style.display = "none";

      video.onended = () => {
        playButton.style.display = "block";
      };
    } else {
      video.pause();
      playButton.style.display = "block";
      setCurrentVideoIndex(null);
    }
  };

  const [videoPlaying, setVideoPlaying] = useState([]);

  const handleVideoClick = (postIndex, imageIndex) => {
    const key = `${postIndex}-${imageIndex}`;
    const videoRef = videoRefs.current[key];

    if (videoRef) {
      if (videoPlaying[key]) {
        videoRef.pause();
        setVideoPlaying((prev) => ({ ...prev, [key]: false }));
      } else {
        // Pause all other videos
        Object.keys(videoRefs.current).forEach((otherKey) => {
          if (otherKey !== key && videoRefs.current[otherKey]) {
            videoRefs.current[otherKey].pause();
            setVideoPlaying((prev) => ({ ...prev, [otherKey]: false }));
          }
        });
        videoRef
          .play()
          .then(() => {
            setVideoPlaying((prev) => ({ ...prev, [key]: true }));
          })
          .catch((error) => {
            console.error("Error playing video:", error);
          });
      }
    } else {
      setVideoPlaying((prev) => ({ ...prev, [key]: true }));
      const updatedShowVideos = [...showVideos];
      updatedShowVideos[postIndex] = true;
      if (videoRef) {
        videoRef.play();
      }
      setShowVideos(updatedShowVideos);
      console.warn(`No videoRef found for key: ${key}`);
    }
  };

  const videoRefs = useRef([]);

  const getVideoThumbnail = (videoUrl) => {
    const video1 = videoUrl + ".jpg";
    return video1;
  };

  const handleCloseVideoClick = () => {
    setIsPreviewVideo(false);
    setAttachments("");
  };

  const shareChartAsPost = async (chart) => {
    setChartId(chart?.id);
    setShowModal(true);
  };
  const [sharingInProgress, setSharingInProgress] = useState(false);

  const handleShare = async () => {
    // If sharing is already in progress, return early to prevent multiple clicks
    if (sharingInProgress) return;

    setSharingInProgress(true); // Set flag to indicate sharing is in progress

    try {
      const res = await shareCartAsPostApi(chartId, inputValue);
      if (res?.data?.status === 200) {
        setPreview(false);
        setShowModal(false);
        toast.success(res?.data?.message);
        setInputValue("");
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      console.error("Error sharing cart:", error);
      toast.error("An error occurred while sharing the cart.");
    } finally {
      setSharingInProgress(false); // Reset the flag whether successful or not
    }
  };

  const handleLoadMore = async () => {
    setItemsPerPage(itemsPerPage + 10);
    setPage(page + 1);

    try {
      setLoader(true);
      const response = await getSavedPost(page + 1);

      if (response?.data?.status === 200) {
        const newPosts = response.data.data.data;
        setSavedPost((prevPosts) => [...prevPosts, ...newPosts]);

        // Check if the current page is the last page
        if (page + 1 === response.data.data.last_page) {
          setHasMore(false);
        }
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching saved posts:", error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <DashboardHeader toggle={sidebarToggle} />
      <PageHeaderTitle title={t("Saved Folders")} />
      <PageContainer>
        <>
          <div className="bg-white">
            <main className="h-full bg-#fbfcfc pt-4 justify-center">
              <div
                className={
                  isMobileView
                    ? "py-6 px-2 rounded-2xl bg-[#FBFCFC] max-w-[53rem] w-full mx-auto mb-10"
                    : "p-8 rounded-2xl bg-[#FBFCFC] max-w-[53rem] w-full mx-auto"
                }
              >
                <div className="flex justify-center space-x-4 mb-4">
                  <button
                    onClick={() => handleTabChange("savedPost")}
                    className={`px-4 py-2 rounded focus:outline-none transition-colors ${selectedTab === "savedPost"
                      ? "bg-teal-900 text-white border"
                      : "bg-white text-[#8A8B8F] hover:bg-teal-900 hover:text-white border"
                      }`}
                  >
                    Posts
                  </button>
                  <button
                    onClick={() => handleTabChange("savedCharts")}
                    className={`px-4 py-2 rounded focus:outline-none transition-colors ${selectedTab === "savedCharts"
                      ? "bg-teal-900 text-white border"
                      : "bg-white text-[#8A8B8F] hover:bg-teal-900 hover:text-white border"
                      }`}
                  >
                    Charts
                  </button>
                </div>
                {!loader && selectedTab === "savedPost" ? (
                  <>
                    {savedPost && savedPost.length > 0 ? (
                      savedPost.map((postDataItem, index) => {
                        const post = postDataItem.post;
                        if (!post || !post.user) {
                          return null;
                        }
                        return (
                          <div
                            key={index}
                            className={
                              isMobileView
                                ? "text-white mb-1 flex flex-col"
                                : "text-white py-4 mb-4 flex flex-col"
                            }
                          >
                            <div className="flex justify-between">
                              <div className="flex items-center mb-2 justify-between">
                                <div className="flex items-center">
                                  <img
                                    src={post?.user?.image}
                                    className="object-cover h-9 w-9 mr-2 rounded-full"
                                    alt={`${post.user.user_name}'s profile`}
                                  />
                                  {/* <span
                                    className={
                                      isMobileView
                                        ? "px-1 text-[17px] text-black font-bold font-poppins whitespace-nowrap"
                                        : "px-1 ml-2 sm:ml-[16] text-[17px] text-black font-bold font-poppins whitespace-nowrap"
                                    }
                                  >
                                    {post?.user?.user_name}
                                  </span> */}

                                  <span
                                    className={
                                      isMobileView
                                        ? "px-1 text-[19px] sm:ml-[0] text-auto text-black font-bold font-poppins truncate"
                                        : "px-1 sm:ml-[0] text-[20px] text-black font-bold font-poppins truncate"
                                    }
                                  >
                                    {/* @QUSHI */}@{post.user.user_name}
                                  </span>
                                  {post?.user?.green_tick ? (
                                    <img
                                      alt="green_tick"
                                      className="object-cover"
                                      src={GreenTick}
                                    />
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                              <div className="flex mb-2 justify-between">
                                <span
                                  className={
                                    isMobileView
                                      ? "sm:ml-[0] mt-1 mr-3 text-base text-gray-600 font-poppins"
                                      : "sm:ml-[0] mt-1 mr-6 text-base text-gray-600 font-poppins"
                                  }
                                >
                                  {calculateTimeDifference(
                                    postDataItem.created_at
                                  )}
                                </span>
                                <div className="relative inline-block  text-right">
                                  <button
                                    onClick={() => toggleDropdown(index)}
                                    type="button"
                                    className="w-full bg-white-400 text-green-700 px-2 py-2 hover:bg-primaryColor hover:text-white rounded flex items-center"
                                  >
                                    <FontAwesomeIcon icon={faEllipsisV} />
                                  </button>
                                  {dropdownStates[index] && (
                                    <div className="z-50 origin-top-right text-green-500 absolute right-0 mt-0 w-10 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 mr-[-10px]">
                                      <button
                                        onClick={() =>
                                          handleOpenModal(postDataItem.id)
                                        }
                                        className="block text-primaryColor px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                        role="menuitem"
                                      >
                                        <div className="flex flex-row  justify-center items-center">
                                          <FontAwesomeIcon icon={faTrash} />
                                        </div>
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="ml-3 mt-2 px-0 my-2 sm:px-10 font-poppins">
                              {/* {post.description && (
                                <p className="text-sm text-black">
                                  {post.description}
                                </p>
                              )} */}

                              <div className="text-[18px] font-poppins text-[#707070]">
                                {showFullDescription[index]
                                  ? renderDescriptionDynamicLineBreaks(
                                    post?.description
                                  )
                                  : post?.description?.length > 255
                                    ? renderDescriptionDynamicLineBreaks(
                                      post?.description.substring(0, 255)
                                    )
                                    : renderDescriptionDynamicLineBreaks(
                                      post?.description
                                    )}
                                {post?.description &&
                                  post?.description.length > 255 && (
                                    <button
                                      onClick={() => {
                                        setShowFullDescription((prevState) => {
                                          const newState = [...prevState];
                                          newState[index] = !newState[index];
                                          return newState;
                                        });
                                      }}
                                      className="text-green-500 ml-1"
                                    >
                                      {showFullDescription[index]
                                        ? "Show less"
                                        : "Show more"}
                                    </button>
                                  )}
                              </div>
                            </div>
                            <div className="ml-3 flex px-0 my-2 sm:px-10 flex-wrap">
                              {post.post_image.map((image, imageIndex) => {
                                const key = `${index}-${imageIndex}`;
                                const shouldShowThumbnail =
                                  !showVideos[key] && !videoPlaying[key];
                                return (
                                  <div key={imageIndex} className="mr-4 mb-4">
                                    {videoExtensionsRegex.test(image.image) ? (
                                      <div
                                        className={
                                          post?.repost?.post_image.length == 1
                                            ? isMobileView
                                              ? "w-[300px] h-[350px] relative rounded-lg"
                                              : "w-[780px] h-[400px] relative rounded-lg"
                                            : isMobileView
                                              ? "w-[300px] h-[350px] relative rounded-lg"
                                              : "w-[780px] h-[400px] relative rounded-lg"
                                        }
                                      >
                                        {shouldShowThumbnail ? (
                                          <div>
                                            <img
                                              src={getVideoThumbnail(
                                                image.image
                                              )}
                                              id={`image-${key}`}
                                              className={
                                                post?.repost?.post_image
                                                  .length == 1
                                                  ? isMobileView
                                                    ? "w-[350px] h-[350px] object-cover rounded-lg "
                                                    : "w-[780px] h-[400px] object-cover rounded-lg "
                                                  : isMobileView
                                                    ? "w-[350px] h-[340px] object-cover rounded-lg "
                                                    : "w-[780px] h-[400px]  object-cover rounded-lg "
                                              }
                                              alt="Video Thumbnail"
                                              onClick={(e) => {
                                                handleVideoClick(
                                                  index,
                                                  imageIndex
                                                );
                                              }}
                                            />
                                          </div>
                                        ) : (
                                          <video
                                            ref={(el) =>
                                              (videoRefs.current[key] = el)
                                            }
                                            autobuffer
                                            playsInline={true}
                                            webkit-playsinline="true"
                                            x5-playsinline="true"
                                            x-webkit-airplay="deny"
                                            disablePictureInPicture={true}
                                            controlsList="nodownload"
                                            onContextMenu={(e) =>
                                              e.preventDefault()
                                            }
                                            autoPlay
                                            controls
                                            id={`video-${key}`}
                                            preload="auto"
                                            className="w-full h-full object-cover rounded-lg"
                                            onLoadedMetadata={(e) => {
                                              if (isMobileView) {
                                                e.target.currentTime = 1;
                                              }
                                            }}
                                            onClick={(e) => {
                                              e.target.currentTime = 0;
                                              handleVideoClick(
                                                index,
                                                imageIndex
                                              );
                                            }}
                                          >
                                            <source src={image.image} />
                                          </video>
                                        )}
                                        <button
                                          id={`play-button-${key}`}
                                          className={
                                            videoPlaying[key]
                                              ? "absolute inset-0 flex rounded-lg items-center justify-center text-white"
                                              : "absolute inset-0 flex rounded-lg items-center justify-center bg-opacity-10 text-white"
                                          }
                                          style={{
                                            display: videoPlaying[key]
                                              ? "none"
                                              : "block",
                                          }}
                                          onClick={() => {
                                            handleVideoClick(index, imageIndex);
                                          }}
                                        >
                                          {videoPlaying[key] ? (
                                            ""
                                          ) : (
                                            <FontAwesomeIcon
                                              className="h-7"
                                              icon={
                                                videoPlaying[key]
                                                  ? faPause
                                                  : faPlay
                                              }
                                            />
                                          )}
                                        </button>
                                      </div>
                                    ) : (
                                      <div>
                                        <img
                                          src={image?.image}
                                          alt={`Post Image ${imageIndex + 1}`}
                                          className="w-full h-full"
                                        />
                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                            {isModalOpen && (
                              <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center">
                                <div className="bg-white p-6 rounded shadow-lg text-center">
                                  <div className="flex justify-center items-center my-2">
                                    <img
                                      src={"/qushi_logo.png"}
                                      className="h-24"
                                      alt="logo"
                                    />
                                  </div>
                                  <p className="mb-4 text-primaryColor">
                                    Are you sure you want to delete this post?
                                  </p>
                                  <div className="flex justify-center">
                                    <button
                                      onClick={() => handleDelete()}
                                      className="bg-primaryColor text-white py-2 px-4 rounded mr-2"
                                    >
                                      Delete Post
                                    </button>
                                    <button
                                      onClick={handleCloseModal}
                                      className="bg-red-500 text-white py-2 px-4 rounded"
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="w-full mt-3 h-px bg-gray-300"></div>{" "}
                          </div>
                        );
                      })
                    ) : (
                      <div>
                        <div className="text-center py-4">
                          <p className="font-bold">No Data Found</p>
                        </div>
                      </div>
                    )}
                    {savedPost.length > 10 && page === last_page ? (
                      <div className="text-center">
                        <button
                          className="py-2 px-4 mt-2 text-lg font-bold text-white bg-green-500 hover:bg-green-600 rounded shadow"
                          onClick={handleLoadMore}
                        >
                          More
                        </button>
                      </div>
                    ) : (
                      <div className="text-center py-4">
                        {/* <p className="font-bold">Yay! You have seen it all.</p> */}
                      </div>
                    )}
                  </>
                ) : !loader && selectedTab === "savedCharts" ? (
                  <>
                    {preview && (
                      <div
                        style={{
                          position: "fixed",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                          opacity: "1",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          zIndex: 1000, // Set a higher value to ensure it's above the sidebar
                        }}
                        onClick={() => setPreview(false)}
                      >
                        <TransformWrapper
                          defaultScale={1}
                          defaultPositionX={200}
                          defaultPositionY={100}
                          className="flex items-center justify-center"
                        >
                          {({
                            zoomIn,
                            zoomOut,
                            resetTransform,
                            positionX,
                            positionY,
                            ...rest
                          }) => (
                            <>
                              <TransformComponent className="flex items-center justify-center">
                                <img
                                  src={activeImage}
                                  alt="Preview"
                                  className={isMobileView ? "ml-3" : "ml-6"}
                                  style={{
                                    maxWidth: "95%",
                                    maxHeight: "100%",
                                    objectFit: "contain",
                                  }}
                                />
                              </TransformComponent>
                            </>
                          )}
                        </TransformWrapper>
                      </div>
                    )}
                    {savedCharts && savedCharts.length > 0 ? (
                      savedCharts.map((savedChart, index) => {
                        return (
                          <div
                            key={index}
                            className="text-white px-4 py-6 mb-4 flex flex-col border-2 rounded-xl"
                          >
                            {savedChart?.image && (
                              <div className="flex jusify-between">
                                <img
                                  src={savedChart?.image}
                                  alt="saved-chart"
                                  className="w-full h-80 object-contain cursor-pointer"
                                  onClick={() => showPreview(savedChart.image)}
                                />
                                <div className="relative inline-block  text-right mr-4">
                                  <button
                                    onClick={() => toggleDropdown1(index)}
                                    type="button"
                                    className="w-full bg-white-400 text-green-700 px-2 py-2 hover:bg-primaryColor hover:text-white rounded flex items-center"
                                  >
                                    <FontAwesomeIcon icon={faEllipsisV} />
                                  </button>
                                  {dropdownStates1[index] && (
                                    <div className="origin-top-right text-green-500 absolute right-1 mt-0 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 mr-[-10px]">
                                      <button
                                        className="block w-full text-primaryColor px-2.5 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                        role="menuitem"
                                      >
                                        <div
                                          className="flex ml-2"
                                          onClick={() =>
                                            onShareChartClick(savedChart)
                                          }
                                        >
                                          <FontAwesomeIcon
                                            className="h-3 mt-1"
                                            icon={faTrash}
                                          />{" "}
                                          <p className="ml-2  whitespace-nowrap">
                                            Delete Chart
                                          </p>
                                        </div>
                                      </button>
                                      <button
                                        className="block w-full text-primaryColor px-2.5 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                        role="menuitem"
                                      >
                                        <div
                                          className="flex ml-2"
                                          onClick={() =>
                                            shareChartAsPost(savedChart)
                                          }
                                        >
                                          <FontAwesomeIcon
                                            className="h-3 mt-1 "
                                            icon={faShare}
                                          />{" "}
                                          <p className="ml-2  whitespace-nowrap">
                                            Share Chart as Post
                                          </p>
                                        </div>
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                            {showModal && (
                              <div className="fixed z-50 inset-0 overflow-y-auto">
                                <div className="absolute inset-0 bg-black opacity-75"></div>

                                <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
                                  <div
                                    className="fixed inset-0 transition-opacity"
                                    aria-hidden="true"
                                  >
                                    <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
                                  </div>

                                  <span
                                    className="hidden sm:inline-block sm:align-middle sm:h-screen"
                                    aria-hidden="true"
                                  >
                                    &#8203;
                                  </span>
                                  <div className="px-2 fixed z-50 inset-0 overflow-y-auto flex items-center justify-center">
                                    <div className="bg-white rounded-lg w-full shadow-xl max-w-lg mx-auto sm:my-8 p-6">
                                      {/* Logo */}
                                      <div className="flex justify-center items-center mb-4">
                                        <img
                                          src={"/qushi_logo.png"}
                                          alt="Logo"
                                          className="h-16 w-auto"
                                        />
                                      </div>

                                      {/* Prompt */}
                                      {/* Replaced h2 with input field */}
                                      {/* <input
                                        type="text"
                                        className="text-lg font-bold text-primaryColor mb-4 p-2 border border-gray-300 rounded focus:outline-none focus:border-primaryColor w-full h-24"
                                        placeholder="Add Description for chart"
                                        value={inputValue}
                                        onChange={(e) =>
                                          setInputValue(e.target.value)
                                        }
                                      /> */}
                                        <textarea
                                              className="w-full h-64 p-4 text-lg font-medium text-primaryColor border border-gray-300 rounded focus:outline-none focus:border-primaryColor resize-none mb-4"
                                              placeholder="Add Description for chart"
                                              value={inputValue}
                                              onChange={(e) => setInputValue(e.target.value)}
                                            />

                                      <div className="flex items-center justify-between">
                                        <button
                                          className="bg-primaryColor hover:bg-primaryColor text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                          onClick={handleShare}
                                          disabled={sharingInProgress} // Disable the button when sharing is in progress
                                        >
                                          Share
                                        </button>
                                        <button
                                          className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                          onClick={() => setShowModal(false)}
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {savedChart?.stock_symbol && (
                              <p className="text-black mt-4">
                                {savedChart?.stock_symbol}
                              </p>
                            )}
                            <span className="text-black">
                              {moment(savedChart?.created_at)
                                .local()
                                .format("MMMM DD, YYYY hh:mm A")}
                            </span>
                          </div>
                        );
                      })
                    ) : (
                      <div className="text-center font-bold text-black py-4 px-4 mt-3 mb-4">
                        <p>No Charts Found</p>
                      </div>
                    )}
                  </>
                ) : loader ? (
                  <SmallLoader />
                ) : (
                  ""
                )}
              </div>
            </main>
          </div>
        </>
      </PageContainer>
      <FollowersListModal
        isOpen={isFollowersOpen}
        // handleShareToFollowers={handleShareToFollowers}
        handleShareCancel={handleShareCancel}
      >
        <div>
          <ul className="px-4 max-h-80 overflow-auto mb-2">
            {followersList && followersList.length > 0 ? (
              followersList.map((val, index) => {
                return (
                  <li key={val?.sender?.id} className="">
                    <div className="flex justify-between py-2 bg-gray-100 px-2 rounded-lg mb-4">
                      <div className="flex px-1">
                        <img
                          alt="profile_image"
                          className="object-cover rounded-full w-10 h-10"
                          src={val?.sender?.image}
                        />
                        <p className="px-1 ml-1 mt-2">
                          {val?.sender?.user_name}
                        </p>
                      </div>
                      <div className="px-1">
                        <button
                          disabled={
                            selectedIndices.includes(index) ? true : false
                          }
                          className={
                            selectedIndices.includes(index)
                              ? "text-primaryColor border border-primaryColor rounded-lg px-2 py-2 text-sm cursor-pointer"
                              : "text-white bg-primaryColor rounded-lg px-2 py-2 text-sm cursor-pointer"
                          }
                          onClick={() =>
                            handleShareToFollowers(val?.sender?.id, index)
                          }
                        >
                          Send
                        </button>
                      </div>
                    </div>
                  </li>
                );
              })
            ) : (
              <div className="text-center font-bold text-black py-4 px-4 mt-3 mb-4">
                <p>No Followers Found</p>
              </div>
            )}
          </ul>
        </div>
      </FollowersListModal>
      {isPreviewVideo && (
        <PreviewVideo src={attachments} onClick={handleCloseVideoClick} />
      )}
    </>
  );
};

export default SavedPost;
